module.exports = __webpack_public_path__ + "static/img/bg_3.5378f96.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newImage/bg_3.jpg
// module id = q1hj
// module chunks = 3